const initialState = {
    isLoading: false,
    error: "",
    message: null,
    data: null,
};

export { initialState };